import React from 'react'
export const BannerHpe = () => {
    return (
        <div>
            <img src={process.env.PUBLIC_URL + "banner/bannerHPEiquote.png"} alt="Imagen marcas" className='imagenesBody' loading='lazy'></img>
        </div>
    )
}